import {
    Breadcrumb,
    Button,
    Col,
    Drawer,
    Dropdown,
    Empty,
    Form, FormInstance,
    Input,
    Menu,
    Modal,
    Pagination,
    Popconfirm,
    Row,
    Select,
    Space,
    Table,
    notification
} from "antd";
import React from "react";
import { connect } from "react-redux";
import { NavLink, RouteComponentProps } from "react-router-dom";
import { RootStoreModel } from "../../../redux/reducers";
import {
    BasicStateForListModel
} from "../../models";
//import { TemplateContent } from "./template.content"
import {
    AndroidFilled,
    AppleFilled,
    DownOutlined,
    PlusOutlined,
    createFromIconfontCN
} from '@ant-design/icons';
import {
    addTemplate,
    copyTemplates,
    deleteTemplate,
    getTemplate,
    getTemplateList,
    getTemplateTabs,
} from "../../../axios/api.device";
import { TemplateContentApp } from "./template.contentApp";
import "./template.scss";

import { Translation } from "react-i18next";

const {Column} =Table
const { SubMenu } = Menu;
const { Item } = Form;
const MyIcon = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_2670925_pf3sykyocl.js', // 在 iconfont.cn 上生成
});
interface stateModel extends BasicStateForListModel {
    name: string,
    current: string,
    selectTemplate: string,
    isShowTable: boolean,
    search: string,
    isShowAddForm: boolean,
    selectRow: any,
    showRightBox: boolean
    // showAddDeviceForTemplate: boolean,
    // devicesList: any[],
    selectDevices: any[],
    currentName: string,
    templateTabs: any[],
    dropdownVisible: any[],
    isModify: boolean,
    templateItemsStatus: any,
    templateItemsMap: any,
    isCustom: boolean,
    selectWeek: number,
    dayList: any[],
    worshipDays: any[],
    configFileType: string,
    isSelectdItem: boolean,
    templateSelectItemsMap: any,
    platform:string,
}
interface propsModel extends RouteComponentProps<any, any, any> {
    tokenSuccess: boolean
}
const mapStatetoProps = (state: RootStoreModel) => ({
    tokenSuccess: state.userState.tokenSuccess
});

class TemplateAppIndex extends React.Component<propsModel, stateModel> {
    formRef = React.createRef<FormInstance>();
    constructor(props: propsModel) {
        super(props);
        this.state = {
            name: "TemplateAppIndex",
            current: "Applications",
            currentName: "",
            selectTemplate: "",
            isShowTable: true,
            pageIndex: 1,
            pageSize: 10,
            totalCount: 0,
            search: "",
            loading: false,
            data: [],
            columns: [],
            isShowAddForm: false,
            platform:"",
            selectRow: {},
            showRightBox: false,
            // showAddDeviceForTemplate: false,
            // devicesList: [],
            selectDevices: [],
            templateTabs: [],
            dropdownVisible: [],
            isModify: false,
            isSelectdItem: false,
            templateItemsStatus: {
                App: false,
            },
            templateItemsMap: {
                Applications: "App"
            },
            templateSelectItemsMap: {
                App: "Applications"
            },
            isCustom: false,
            selectWeek: 0,
            dayList: [],
            worshipDays: [],
            configFileType: "Default",
        }
    }
    Init() {
        this.getList();
        // this.getDeviceAll();
        getTemplateTabs().then(c => {
            this.setState({ templateTabs: c })
        });
        if (this.props.history.location.state && Object.keys(this.props.history.location.state).length > 0) {
            this.operationClick({key: 'edit'}, this.props.history.location.state);
        }
    }
    componentDidMount() {
        if (this.props.tokenSuccess) {
            this.Init();
        }

    }
    componentDidUpdate(prevProps: propsModel) {
        if (this.props.tokenSuccess !== prevProps.tokenSuccess) {
            this.Init();
        }
    }
    // getDeviceAll() {

    //     getAllDevices({ pageIndex: 1, pageSize: 999999, platform: "IOS" }).then(res => {
    //         this.setState({ devicesList: res.dataList })
    //     });
    // }
    deviceHandleChange(value: any[]) {
        this.setState({ selectDevices: value });
    }
    getList(pageIndex = this.state.pageIndex,
        pageSize = this.state.pageSize) {
        var temArg = {
            pageIndex: pageIndex,
            pageSize: pageSize,
            search: this.state.search,
            category: "App"
        }
        getTemplateList(temArg).then(
            (res) => {
                this.setState({
                    data: res.dataList,
                    pageSize: res.pageSize,
                    pageIndex: res.pageIndex,
                    loading: false,
                    totalCount: res.totalCount,
                    dropdownVisible: [],
                });
                res.dataList.forEach((item: any) => {
                    this.state.dropdownVisible.push({key: item.id, value: false});
                });
            })
    }
    templateNameUpdate = (e: any) => {
        console.log(e);
        var sele = {
            name: e.target.value,
            id: this.state.selectRow.id,
            platform: this.state.selectRow.platform,
            status: this.state.selectRow.status,
            category: "App"
        }
        this.setState({ selectRow: sele })
    }
    // addDevicesForTemplateClick() {
    //     this.setState({ loading: true })
    //     addDeviceForTemplate(this.state.selectRow.id, { deviceIds: this.state.selectDevices }).then(c => {
    //         notification.success({ message: <Translation>{t => {return t("添加成功")}}</Translation> });
    //         this.setState({ showAddDeviceForTemplate: false, selectDevices: [], loading: false })

    //     })
    // }
    // templateNameClick = (key: string) => {
    //     if (key == "edit") {
    //         this.setState({ showRightBox: true })
    //     }

    // }
    handleMenuClick = (e: any) => {
        var currname = "";
        switch (e.key) {
            case "Applications":
                currname = "应用";
                break;
        }
        console.log(currname);
        this.setState({ current: e.key, currentName: currname });
    };
    onSearch = () => {
        this.getList();

    }
    // updateItemStatus = (e: any, row: any) => {
    //     row.status = e;
    //     addTemplate(row).then(c => {
    //         this.getList();
    //     })

    // }
    subTemplateNameClick() {
        var sele = {
            name: this.state.selectRow.name,
            id: this.state.selectRow.id,
            platform: this.state.selectRow.platform,
            status: this.state.selectRow.status,
            category: "App"
        }
        addTemplate(sele).then(c => {
            this.getList();
            this.setState({ showRightBox: false })
        })
    }
    addTemplateClick = () => {
        this.setState({ loading: true });
        this.formRef.current?.validateFields().then(
            (res) => {
                res.status = "Active";
                res.isCustomized = this.state.isCustom;
                res.executionRules = [];
                res.type = "Default";
                res.category = "App";
                addTemplate(res).then(
                    () => {
                        this.getList();
                        this.setState({ isShowAddForm: false });
                        this.formRef.current?.resetFields();
                        notification.success({message: <Translation>{t => {return `${this.state.isModify ? t("编辑配置文件成功") : t("添加配置文件成功")}`}}</Translation>});
                    },
                    () => { notification.error({message: <Translation>{t => {return `${this.state.isModify ? t("编辑配置文件失败") : t("添加配置文件失败")}`}}</Translation>}) }
                ).finally(
                    () => { 
                        this.setState({
                            loading: false, 
                            isModify: false, 
                            configFileType: "Default", 
                            isCustom: false,
                            dayList: [],
                            selectWeek: 0,
                            worshipDays: []
                        }) 
                    }
                )
            },
            () => { this.setState({loading: false}) }
        )
    }
    operationClick = (e: any, row: any) => {
        if (!e.key) {
            return
        }
        switch (e.key) {
            case "edit":
                var obj = {current: "Applications", name: "应用"};
                this.formRef.current?.setFieldsValue(row);
                this.setState({ 
                    isShowTable: false, 
                    currentName: obj.name, 
                    current: obj.current,
                    selectRow: row,
                });
                this.getSelectedTemplate(row.id);
                //this.getList();
                break;
            case "delete":
                deleteTemplate(row.id).then(
                    () => {
                        notification.success({ message: <Translation>{t => {return t("删除成功")}}</Translation> });
                        this.getList();
                    }, 
                    () => { notification.error({ message: <Translation>{t => {return t("删除失败")}}</Translation> }) }
                )
                break;
            case "copy":
                copyTemplates({id: row.id, name: `${row.name}_拷贝`}).then(
                    () => {
                        notification.success({ message: <Translation>{t => {return t("拷贝成功")}}</Translation> });
                        this.getList();
                    }, 
                    () => { notification.error({ message: <Translation>{t => {return t("拷贝失败")}}</Translation> }) }
                )
                break;
            case "modify":
                getTemplate(row.id).then(
                    res => {
                        this.formRef.current?.setFieldsValue(row);
                        var worshipDays: any[] = [];
                        var dayList: any[] = [];
                        this.setState({
                            isModify: true, 
                            isShowAddForm: true, 
                            configFileType: res.type,
                            isCustom: res.isCustomized,
                            dayList: dayList,
                            worshipDays: worshipDays
                        });
                    },
                    () => {
                        notification.error({message: <Translation>{t => {return t("获取配置文件失败")}}</Translation>})
                    }
                )
                break;
            case "devices":
                this.props.history.push({
                    pathname: `/home/profiles/devices/${row.id}`, 
                    state: row
                });
                break;
        
            default:
                break;
        }
    }
    onClose = () => {
        this.setState({
            showRightBox: false,
        });
    };
    getTemplateTab = () => {
        var tab = this.state.templateTabs.find(c => {
            return c.tabKey === this.state.current;
        })
        return tab;

    }

    getSelectedTemplate = (templateId: string) => {
        this.setState({ isSelectdItem: false });
        getTemplate(templateId).then(
            (res) => {
                const {selectdItemList} = res;
                const {templateSelectItemsMap} = this.state;
                const items: any = {};
                if (selectdItemList.length > 0) {
                    var current = templateSelectItemsMap[selectdItemList[0]]
                    this.setState({ isSelectdItem: true,current: current });
                    selectdItemList.forEach((item: any) => {
                        items[item] = true;
                    })
                }
                this.setState({templateItemsStatus: items});
                
            },
            () => { notification.error({message: <Translation>{t => {return t("获取模板数据失败")}}</Translation>}) }
        )
    }

    updateTemplate = () => {
        this.getSelectedTemplate(this.state.selectRow.id);   
    }

    getCurret = () => {
        var item = this.state.dayList?.find(c => {
            return c.worshipDay === this.state.selectWeek;
        })
        return item;
    }


    selectTypeChange(key: boolean) {
        this.setState({isCustom: key});
        if (!key) {
            for (var i = 0; i < this.state.dayList.length; i++) {
                this.state.dayList[i] = Object.assign({}, this.state.dayList[this.state.selectWeek])
            }
            this.setState({dayList: [...this.state.dayList]});
        }
    }

    render() {
        const { 
            name, current, selectTemplate, isShowTable, templateItemsStatus, 
            templateItemsMap, data, pageIndex, pageSize, totalCount, search, 
            loading, isShowAddForm, selectRow, showRightBox, 
            selectDevices, currentName, dropdownVisible, isModify, 
            isCustom, selectWeek, configFileType, worshipDays, isSelectdItem
        } = this.state;
        return (
            (<Translation>{t => {
                    return (
                        (<div>
                            <div className="breadcrumbTop py-2">
                                <Breadcrumb>
                                   
                                    <Breadcrumb.Item>{t("配置文件")}</Breadcrumb.Item>
                                    <Breadcrumb.Item>  
                                        <a onClick={() => {
                                            this.setState({ 
                                                isShowTable: true, 
                                                currentName: "", 
                                                current: "",
                                                templateItemsStatus: {
                                                    App: false,
                                                }, 
                                            });
                                            this.props.history.replace("/home/profiles/appIndex");
                                        }}>{t("应用")}</a>
                                    </Breadcrumb.Item>
                                    {currentName?.trim() ? <Breadcrumb.Item>{t(currentName)}</Breadcrumb.Item> : null}
                                </Breadcrumb>
                                {!currentName && (
                                    <Row style={{padding: "32px 0 11px 0"}}>
                                        <Space>
                                            <img src="/images/profileIcon.svg" alt="" />
                                            <span style={{display: "flex", fontSize: 22, fontWeight: 500, marginTop: -5}}>{t("应用配置文件")}</span>
                                        </Space>
                                    </Row>
                                )}
                            </div>
                            <Row style={{ width: "100%" }}>
                                {!isShowTable && (
                                    <div className="borderBox">
                                        <Row style={{height: "36px", borderBottom: "1px solid #F1F1F1"}}>
                                            <Col span={4} style={{textAlign: "center", marginTop: "-3px"}}>
                                                {(selectRow.platform === 'IOS' || selectRow.platform === 'macOS') && (
                                                    <AppleFilled style={{fontSize: 20}}></AppleFilled>
                                                )}
                                                {(selectRow.platform === 'Android') && (
                                                    <AndroidFilled style={{fontSize: 20}}></AndroidFilled>
                                                )}
                                                <span style={{
                                                    fontSize: "16px",
                                                    fontWeight: 600,
                                                    marginLeft: "10px",
                                                }}>{selectRow.name}</span>
                                            </Col>
                                            <Col span={20}>
                                                <NavLink style={{marginLeft: "16px"}} to={{
                                                    pathname: `/home/profiles/devices/${selectRow.id}`, 
                                                    state: selectRow, 
                                                }}>
                                                    <img src="../../images/App.png" style={{marginTop: "-3px"}} alt="" />
                                                    <span>{t("关联设备")}</span>
                                                </NavLink>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col span={4}>
                                                <Menu mode="inline" defaultSelectedKeys={['Applications']} defaultOpenKeys={['Applications']}
                                                    onClick={this.handleMenuClick} selectedKeys={[current]}
                                                >
                                                    {(!["IOS", "macOS"].includes(selectRow.platform) || (["IOS", "macOS"].includes(selectRow.platform) && selectRow.type !== "Schedule")) && (<Menu.Item key="Applications">
                                                        <div style={{display: "flex", justifyContent: "space-between"}}>
                                                            <span>{t("应用")}</span> 
                                                            {templateItemsStatus[templateItemsMap["Applications"]] && <img src="../../images/icon3.png" alt="" style={{height: "14px", marginTop: "13px"}}/>}
                                                        </div>
                                                    </Menu.Item>)}
                                                </Menu>
                                            </Col>
                                            <Col span={20}>
                                                {current === "Applications" && (
                                                    <TemplateContentApp templateId={selectRow.id} platform={selectRow.platform} templateTab={this.getTemplateTab()} updateTemplate={this.updateTemplate}></TemplateContentApp>
                                                )}
                                            </Col>
                                        </Row>
                                    </div>
                                )}
                                {isShowTable && (
                                    <>
                                        <div className="borderBox">
                                            <Row  className="mb-3">
                                                <Col > 
                                                {t("配置文件名称")}:
                                                <Input placeholder="" value={search}
                                                style={{ width: "200px", marginLeft: 10 }}
                                                    onChange={(e) => this.setState({ search: e.target.value })} /></Col>
                                                <Col offset={1}>
                                                    <Button type="primary" onClick={() => { this.onSearch(); }}>
                                                        {t("查询")}
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </div>
                                        <div className="borderBox">
                                            <Row>
                                                <Col className="ms-auto" style={{ marginBottom: 8 }}>  <Button type="primary"
                                                    onClick={() => { this.setState({ isShowAddForm: true }) }}><PlusOutlined />{t("添加")} {t("配置文件")}</Button></Col>
                                            </Row>
                                            <Row  >
                                                <Col span={24}>
                                                    <Table 
                                                        size="middle" 
                                                        dataSource={data} 
                                                        rowKey={recored => recored.id} 
                                                        style={{ width: "100%", minHeight: 300 }} 
                                                        pagination={false}
                                                        locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
                                                    >
                                                        <Column
                                                            title={t("配置文件名称")}
                                                            key="name"
                                                            dataIndex="name"
                                                        ></Column>
                                                        <Column
                                                            title={t("配置文件类型")}
                                                            key="type"
                                                            dataIndex="type"
                                                            render={(v: any) => {
                                                                return v === "Default" ? t("长效") : v === "Schedule" ? t("定时") : v
                                                            }}
                                                        ></Column>
                                                        <Column
                                                            title={t("平台")}
                                                            key="platform"
                                                            dataIndex="platform"
                                                            render={(v: any) =>{
                                                                return (
                                                                <div >
                                                                {v==="Android"&&(
                                                                    <span>< AndroidFilled style={{color:"#999999",fontSize:20}}/>&nbsp;&nbsp;Android</span>
                                                                )}
                                                                {v==="IOS"&&(
                                                                    <span><AppleFilled style={{color:"#999999",fontSize:20}}/>&nbsp;&nbsp;iOS</span>
                                                                )}
                                                                {v==="macOS"&&(
                                                                    <span><img src="/images/macLogo.png" alt="" />&nbsp;&nbsp;macOS</span>
                                                                )}
                                                                </div>)
                                                                }}
                                                        ></Column>
                                                        {/* <Column title="创建人" key="model" dataIndex="model"></Column> */}

                                                        <Column
                                                            title={t("创建时间")}
                                                            key="createTime"
                                                            dataIndex="createTime"
                                                        ></Column>
                                                        <Column
                                                            title={t("最近修改时间")}
                                                            key="updateTime"
                                                            dataIndex="updateTime"
                                                        ></Column>
                                                        <Column
                                                            title={t("关联设备")}
                                                            key="deviceCount"
                                                            dataIndex="deviceCount"
                                                            align="center"
                                                            render={(v, row: any, index) => {
                                                                return (
                                                                    <NavLink to={{ pathname: `/home/profiles/devices/${row.id}`, state: row }} >{v}</NavLink>
                                                                )
                                                            }}
                                                        ></Column>
                                                        <Column
                                                            title={t("安装状态")}
                                                            align="center"
                                                            render={(v, row: any, index) => {
                                                                return (
                                                                    <NavLink to={{ pathname: `/home/profiles/appinstall/${row.id}`, state: row }} >{t("查看")}</NavLink>
                                                                )
                                                            }}
                                                        ></Column>
                                                        <Column
                                                            title={t("操作")}
                                                            key="id"
                                                            dataIndex="id"
                                                            align="center"
                                                            render={(v, raw, index) => {
                                                                return (
                                                                    <Dropdown
                                                                        open={dropdownVisible.length > 0 && dropdownVisible[index]['value']}
                                                                        onOpenChange={(visible) => {
                                                                            const tempList: any[] = [];
                                                                            dropdownVisible.forEach((item) => {
                                                                                if (item.key === v) {
                                                                                    item['value'] = visible;
                                                                                }
                                                                                tempList.push(item);
                                                                            })
                                                                            this.setState({dropdownVisible: tempList});
                                                                        }}
                                                                        // trigger={['click']}
                                                                        dropdownRender={() => (
                                                                            <Menu onClick={(res) => this.operationClick(res, raw)}>
                                                                                <Menu.Item key='edit'>{t("编辑明细")}</Menu.Item>
                                                                                <Menu.Item key='modify'>{t("基本信息")}</Menu.Item>
                                                                                <Menu.Item key='devices'>{t("关联设备")}</Menu.Item>
                                                                                <Popconfirm title={"确认删除?"} onConfirm={() => this.operationClick({key: 'delete'}, raw)}>
                                                                                    <Menu.Item key='delete' className="custom-menu-item">{t("删除")}</Menu.Item>
                                                                                </Popconfirm>
                                                                                <Menu.Item key='copy'>{t("拷贝")}</Menu.Item>
                                                                            </Menu>
                                                                        )}>
                                                                        <a>{t("更多")}<DownOutlined /></a>
                                                                    </Dropdown>
                                                                )
                                                            }}></Column>
                                                    </Table>
                                                    <Pagination
                                                        style={{ textAlign: "right", marginTop: "20px" }}
                                                        pageSize={pageSize}
                                                        current={pageIndex}
                                                        total={totalCount}
                                                        showTotal={(total, range) =>
                                                            `${range[0]}-${range[1]} / ${total} ${t("条")}`
                                                        }
                                                        onChange={(page, pageSize) => {
                                                            this.getList(page, pageSize);
                                                        }}
                                                        onShowSizeChange={(current, size) => this.getList(current, size)}
                                                    ></Pagination>
                                                </Col>
                                            </Row>
                                            <Modal
                                                confirmLoading={loading}
                                                maskClosable={false}
                                                open={isShowAddForm}
                                                destroyOnClose={true}
                                                title={`${isModify ? "" : t("添加")} ${t("配置文件")}`}
                                                forceRender={true}
                                                width={"650px"}
                                                onOk={() => { this.addTemplateClick() }}
                                                onCancel={() => {
                                                    this.setState({ 
                                                        isShowAddForm: false,
                                                        isModify: false, 
                                                        loading: false,
                                                        configFileType: "Default",
                                                        isCustom: false,
                                                        dayList: [],
                                                        selectWeek: 0,
                                                        worshipDays: []
                                                    });
                                                    this.formRef.current?.resetFields();
                                                }}
                                                okText={t("确认")}
                                                cancelText={t("取消")}
                                            >
                                                <Form
                                                    // labelCol={{ span: 6 }}
                                                    ref={this.formRef}
                                                    layout="vertical"
                                                    initialValues={{ name: "", platform: "IOS", status: "Draft", type: "Default" }}
                                                >
                                                    <Item label="ID" name="id" hidden>
                                                        <Input></Input>
                                                    </Item>
                                                    <Item label={t("配置文件名称")} name="name" rules={[{ required: true }]}>
                                                        <Input></Input>
                                                    </Item>
                                                    <Item label={t("平台")} name="platform" rules={[{ required: true }]}>
                                                        <Select disabled={isModify}>
                                                            <Select.Option value="IOS">iOS</Select.Option>
                                                            <Select.Option value="Android">{t("安卓")}</Select.Option>
                                                            <Select.Option value="macOS">macOS</Select.Option>
                                                        </Select>
                                                    </Item>
                     
                                                </Form>
                                            </Modal>
                                        </div>
                                    </>
                                )}
                            </Row>
                            <Drawer
                                title="编辑配置文件"
                                placement="right"
                                closable={true}
                                onClose={this.onClose}
                                open={showRightBox}
                                footer={
                                    <div
                                        style={{
                                            textAlign: 'right',
                                        }}
                                    >
                                        <Button onClick={this.onClose} style={{ marginRight: 8 }}>
                                            取消
                                        </Button>
                                        <Button onClick={() => { this.subTemplateNameClick() }} type="primary">
                                            提交
                                        </Button>
                                    </div>
                                }
                            >
                                <Row>
                                    <Col span={6}>名称</Col>
                                </Row>
                                <Row>
                                    <Col span={24}><Input value={selectRow?.name} onChange={this.templateNameUpdate}></Input></Col>
                                </Row>

                            </Drawer>
                            {/* <Modal
                                confirmLoading={loading}
                                maskClosable={false}
                                visible={showAddDeviceForTemplate}
                                title="关联设备"
                                width={"650px"}

                                onOk={() => this.addDevicesForTemplateClick()}
                                onCancel={() => this.setState({ showAddDeviceForTemplate: false })}>
                                <Select
                                    mode="multiple"
                                    showArrow
                                    value={selectDevices}
                                    onChange={(values: any[]) => {
                                        this.setState({ selectDevices: values })
                                    }}
                                    style={{ width: '100%' }}>
                                    {
                                        devicesList?.map(item => (
                                            <Select.Option key={item.id} value={item.id} label={item.model}>{item.model}</Select.Option >
                                        ))
                                    }
                                </Select>

                            </Modal> */}
                        </div>)
                    );
                }}</Translation>)
        );
    }
}
export default connect(mapStatetoProps, {})(TemplateAppIndex);